import React, { useState, useEffect, useContext } from "react";

import { ProductType } from "../../../../../../utils/Order/Order";
import BoxEquity from "./BoxEquity";
import BoxBonds from "./BoxBonds";
import style from "./Info.module.scss";
import CircularProgress from "../../../../../CircularProgress/CircularProgress";
import { Dispatch } from "../../../store/store";
import { FormattedNumber } from "../../../../../FormattedNumber/FormattedNumber";

const Info = ({ assetInfo, form, ...props }) => {
  const [itemsReq, setItemsReq] = useState({ items: null, tradeCurrencies: [], loading: true });
  const {
    state: {
      order: { AssetId },
      ui: { userRole },
    },
  } = useContext(Dispatch);

  useEffect(() => {
    assetInfo().then((assetorderdata) => {
      const items = assetorderdata.items.reduce((obj, item) => {
        obj[item.key] = item.value;
        return obj;
      }, {});

      setItemsReq({
        series: assetorderdata.timeseries,
        loading: false,
        items,
        tradeCurrencies: assetorderdata.settlementCurrency || [],
      });
    });
  }, []);

  if (itemsReq.loading) {
    return (
      <div className={style.info}>
        <CircularProgress sm />
      </div>
    );
  }

  const handleClick = () => {
    if ((userRole === "Advisor" || userRole === "Trader") && AssetId) {
      window.open(`/#/asset/${AssetId}/quotes`, "_blank");
    }
  };

  return (
    <div className={style.info} style={{ cursor: "pointer" }} onClick={handleClick}>
      {
        {
          [ProductType.BOND]: <BoxBonds {...props} items={itemsReq.items} series={itemsReq.series} />,
          [ProductType.MMARKET]: <BoxBonds {...props} items={itemsReq.items} series={itemsReq.series} />,
          [ProductType.EQUITY]: (
            <BoxEquity detailed {...props} items={itemsReq.items} series={itemsReq.series} />
          ),
          [ProductType.OPTION]: (
            <BoxEquity detailed={false} {...props} items={itemsReq.items} series={itemsReq.series} />
          ),
          [ProductType.FOREX]: (
            <BoxForex {...props} items={itemsReq.items} tradeCurrencies={itemsReq.tradeCurrencies} />
          ),
          [ProductType.MFUNDS]: <BoxBonds {...props} items={itemsReq.items} series={itemsReq.series} />,
        }[form]
      }
    </div>
  );
};

const BoxForex = ({ items, tradeCurrencies, value, value2 }) => {
  let baseCurrency = value;
  let priceCurrency = value2;

  const tradeCurrency = tradeCurrencies.find((c) => c.currencyInfo.currencyISO == value2);
  if (tradeCurrency && tradeCurrency.multiplies) {
    baseCurrency = value2;
    priceCurrency = value;
  }

  return (
    <div>
      <span>{baseCurrency}</span>/<span>{priceCurrency} </span>{" "}
      <strong>
        <FormattedNumber
          value={items["Ref Price"]}
          decimalScale={items.MaxDecimals}
          dataTypeDecimalName="price"
        />
      </strong>
    </div>
  );
};

export default Info;
